import React from 'react';

import type { ISubmissionFormState } from 'widget/types/submissionFormState';

const SubmissionFormContext = React.createContext<ISubmissionFormState | null>(
  null
);

export const SubmissionFormProvider = SubmissionFormContext.Provider;

/**
 * Хук для доступа к ISubmissionFormState внутри BaseWidget.
 * Возвращает null, если стор не был предоставлен.
 */
export const useSubmissionFormStore = (): ISubmissionFormState | null => {
  return React.useContext(SubmissionFormContext);
};
